import { render, staticRenderFns } from "./GuideArticleView.vue?vue&type=template&id=30bc1734"
import script from "./GuideArticleView.vue?vue&type=script&lang=js"
export * from "./GuideArticleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports